import { NotificationsTranslations } from '../en-US/notifications.translations';

export const notificationsTranslations: NotificationsTranslations = {
  title: 'Benachrichtigungen',
  pageTitle: 'Benachrichtigungen',
  pageDescription: 'Benachrichtigungen anzeigen und verwalten',
  settingsTitle: 'Benachrichtigungseinstellungen',
  settingsPageTitle: 'Benachrichtigungseinstellungen',
  settingsPageDescription: 'Benachrichtigungseinstellungen verwalten',
  settings: 'Einstellungen',
  markAsRead: 'Als gelesen markieren',
  markAllAsRead: 'Alle als gelesen markieren',
  delete: 'Löschen',
  more: 'mehr',
  noNotifications: 'Keine Benachrichtigungen',
  emptyDescription: 'Sie haben noch keine Benachrichtigungen',
  errorLoading: 'Fehler beim Laden der Benachrichtigungen',
  errorLoadingSettings: 'Fehler beim Laden der Benachrichtigungseinstellungen',
  tryAgain: 'Bitte versuchen Sie es später erneut',
  enableNotifications: 'Benachrichtigungen aktivieren',
  enablePromptMessage: 'Bleiben Sie über die neuesten Bewertungen, Likes und Follower informiert, indem Sie Benachrichtigungen aktivieren.',
  remindLater: 'Später erinnern',
  enable: 'Aktivieren',
  stayUpdated: 'Bleiben Sie auf dem Laufenden',
  enableDescription: 'Aktivieren Sie Benachrichtigungen, um über neue Bewertungen, Likes und Follower informiert zu bleiben.',
  pushNotifications: 'Push-Benachrichtigungen',
  pushDescription: 'Benachrichtigungen auf Ihrem Gerät erhalten',
  emailNotifications: 'E-Mail-Benachrichtigungen',
  emailDescription: 'Benachrichtigungen per E-Mail erhalten',
  enableAllNotifications: 'Alle Benachrichtigungen aktivieren',
  masterToggleDescription: 'Alle Benachrichtigungen ein-/ausschalten',
  notificationTypes: 'Benachrichtigungstypen',
  types: {
    reviewLiked: 'Bewertung gefällt',
    reviewLikedDescription: 'Benachrichtigung erhalten, wenn jemandem Ihre Bewertung gefällt',
    newPlaceReviews: 'Neue Ortsbewertungen',
    newPlaceReviewsDescription: 'Benachrichtigung erhalten, wenn ein neuer Ort bewertet wird',
    newFoodReviews: 'Neue Essensbewertungen',
    newFoodReviewsDescription: 'Benachrichtigung erhalten, wenn ein neues Essen bewertet wird',
    newReviewCreated: 'Neue Bewertung erstellt',
    newReviewCreatedDescription: 'Benachrichtigung erhalten, wenn eine neue Bewertung erstellt wird',
    userFollowed: 'Benutzer gefolgt',
    userFollowedDescription: 'Benachrichtigung erhalten, wenn Ihnen ein Benutzer folgt',
  },
}; 

export default notificationsTranslations;
